module.exports = __webpack_public_path__ + "img/bg1-left-side.63b82014.svg";